var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTrash = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M91,346H88a3,3,0,0,0-3-3H83a3,3,0,0,0-3,3H77a1,1,0,0,0,0,2h1v8a3,3,0,0,0,3,3h6a3,3,0,0,0,3-3v-8h1a1,1,0,0,0,0-2Zm-8-1h2a1,1,0,0,1,1,1H82A1,1,0,0,1,83,345Zm5,11a1,1,0,0,1-1,1H81a1,1,0,0,1-1-1v-8h8Zm-3.5-6v5a.5.5,0,0,1-1,0v-5a.5.5,0,0,1,1,0Zm2,1v3a.5.5,0,0,1-1,0v-3a.5.5,0,0,1,1,0Zm-4,0v3a.5.5,0,0,1-1,0v-3a.5.5,0,0,1,1,0Z",
  transform: "translate(-72 -339)"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash.23c3b015.svg";
export { ForwardRef as ReactComponent };